import { SummaryItemDto, SummaryItemModel } from 'api/dto/new/SummaryCompared/SummaryItem.dto';
import {
  QuestionItemDto,
  QuestionItemModel,
} from 'api/dto/new/SummaryCompared/Questions/QuestionItem.dto';
import { SimpleProject } from 'model/SimpleProject';
import { simpleProjectMapper } from 'container/simpleProjectMapper';
import { SimpleProjectApi } from 'api/SimpleProjectApi';

export type SummaryPulseLifecycleComparedDto = {
  groups: Record<string, string>;
  numberOfRespondents: number;
  summary: SummaryItemDto[];
  questions: QuestionItemDto[];
};

export type SummaryPulseLifecycleComparedModel = {
  groups: Record<string, string>;
  numberOfRespondents: number;
  summary: SummaryItemModel[];
  questions: QuestionItemModel[];
};

export const mapSummaryPulseLifecycleComparedDtoToSimpleProjectCompare = (
  dto: SummaryPulseLifecycleComparedDto
): SimpleProject.Compare => {
  // Temporal solution to quickly switch to new API
  return simpleProjectMapper.deserializeCompare((dto as unknown) as SimpleProjectApi.EntryCompare);
};

// TODO: use this mapper later for new endpoint proper typing - https://buzzing.atlassian.net/browse/RPT-322
// export const mapSummaryPulseLifecycleComparedDtoToModel = (
//   dto: SummaryPulseLifecycleComparedDto
// ): SummaryPulseLifecycleComparedModel => ({
//   groups: dto.groups,
//   numberOfRespondents: dto.numberOfRespondents,
//   summary: dto.summary,
//   questions: dto.questions.map(mapQuestionItemDtoToModel),
// });
